import React from "react"
import NumberSpinner from "../NumberSpinner/NumberSpinner";
import DatePickerInput from "../DatePickerInput/DatePickerInput";
import DateHelper from "../DateHelper/DateHelper";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import SurveyFormFileUploadBuilder from "../SurveyFormFileUploadBuilder/SurveyFormFileUploadBuilder";

class TestSurveyForm extends React.Component {

  constructor(props) {
    super(props)
    this.state ={
      ...this.props,
      answers: this.props.answers || [],
      rating_answers: this.props.rating_answers || [],
      emoji_answers: this.props.emoji_answers || [],
      dateFormat: this.props.date_format || '',
      test: this.props.form_fields || [],
      loading: false,
      submitDisabled: true,
      file_upload_group: [{ file_uploads: [] }],
      customer_image_form_field_id: '',
    }
    this.onChangeDate = this.onChangeDate.bind(this);
    this.onChangeFormFields = this.onChangeFormFields.bind(this)
    this.onChangeSurveyFormFields = this.onChangeSurveyFormFields.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this)
    this.onChangeSelectedEmoji = this.onChangeSelectedEmoji.bind(this)
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this)
  }

  componentDidUpdate(nextProps, nextState) {
    var field_ids = []
    var answersFilledArray = []
    var submitValid = true
    var required_fields = this.props.form_fields.filter(field => field.required == true);

    required_fields.map((field) => {
      field_ids.push(field.id)
    })
    
    nextState.answers.map((answer) => {
      if(answer.answer.length > 0 && field_ids.includes(answer.form_field_id)) {
        answersFilledArray.push(true)
      }
    })
    nextState.rating_answers.map((answer) => {
      if(answer.selected == true  && field_ids.includes(answer.form_field_id)) {
        answersFilledArray.push(true)
      }
    })
    nextState.emoji_answers.map((answer) => {
      if(answer.selected == true  && field_ids.includes(answer.form_field_id)) {
        answersFilledArray.push(true)
      }
    })

    if(nextState.file_upload_group != [{ file_uploads: [] }] && field_ids.includes(this.state.customer_image_form_field_id)) {
      answersFilledArray.push(true)
    }    

    if(answersFilledArray.length == required_fields.length) {
      submitValid = false
    }

    if(answersFilledArray.length != required_fields.length) {
      submitValid = true
    }

    if(submitValid != this.state.submitDisabled) {
      this.setState({submitDisabled: submitValid})
    } 
  }

  render() {
    return (
      <div className="OrderFormBuilder justify-content-center" ref="form">
        <div className='panel panel-default'>
          <div className="panel-body container">
            {this.renderHeaderErrors()}
            {this.renderFormFields(this.props.form_fields)}
            <button type="submit"  onClick={e => this.onSubmit(e)} style={{opacity: this.state.submitDisabled ? '.65' : ''}} className="btn">{I18n.t('submit')} </button>
            <LoadingSpinner show={this.state.loading} />
          </div>
        </div>
      </div>
    )
  }

  renderFormFields(form_fields) { 
    var formFields = form_fields.map((form_field) => {
      var form_field_answer = null
      if(this.state.answers != []) {
        var customerAnswers = this.state.answers
        customerAnswers.map((answer) => {
          if(answer.form_field_id == form_field.id){
            form_field_answer = answer.answer
          }
        })
      }
      var customerFieldOptions = form_field.options.map((form_field_option, index) => {
        return <option key={index} value={form_field_option.option}>{form_field_option.option}</option>
      })

      if(form_field.field_type == "text_field_single_line") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <input className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields}  />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div> 
        )
      }

      if(form_field.field_type == "select_box") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group ">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <select className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : "please_select_one"} onChange={this.onChangeFormFields} >
                <option value="please_select_one">{I18n.t("select_ellipsis")}</option>
                {customerFieldOptions}
              </select>
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "number_input") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <NumberSpinner
                name='number'
                id={form_field.id}
                onChange={this.onChangeFormFields}
                value={form_field_answer ?  form_field_answer : ""}
                hasError={this.renderFieldClasses(form_field.field, true)}
              />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "date_form_field") {
        form_field_answer && typeof form_field_answer == 'string' ? form_field_answer = DateHelper.parseDateFromBackend(form_field_answer) : null;
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <DatePickerInput
                selectedDate={form_field_answer}
                dateFormat={DateHelper.rubyToDateFNS(this.state.date_format)}
                customChangeHandler={this.onChangeDate}
                customChangeSource="FormField"
                formFieldID={form_field.id}
                classNames={this.state.errors && form_field.required == true ? 'has-errors' : false}
              />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>  
        )
      }

      if(form_field.field_type == "text_area_multi_line") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              <textarea className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields}  />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>      
        )
      }

      if(form_field.field_type == "phone_number") {
        return (
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <label>{I18n.t('mobile_number')}*</label>
              <input type="tel" className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"}  name={form_field.id} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields}  />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "numbered_scale") {
        var current_rating_answer = []

        this.state.rating_answers.map((rating_answer) => {
          if(rating_answer.form_field_id == form_field.id) {
            current_rating_answer = rating_answer 
          }
        }) 

        return (
          <div className="col-sm-4" key={form_field.id} style={{paddingBottom: "10px"}}>
            <div className="form-group">
              <label style={{paddingBottom: "10px"}}>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
              {this.renderRatingRangeForm(form_field, current_rating_answer)}
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>
        )
      }

      if(form_field.field_type == "emoji_rating") {
        var current_emoji_answer = []

        this.state.emoji_answers.map((emoji_answer) => {
          if(emoji_answer.form_field_id == form_field.id) {
            current_emoji_answer = emoji_answer 
          }
        })

        return (
          <div className="col-sm-4" key={form_field.id}>
            <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
            {this.renderEmojiRatingForm(form_field, current_emoji_answer)}
            {this.renderFieldErrors(form_field.field)}
            <br></br>
          </div>      
        )
      }

      if(form_field.field_type == "signature_generator") {
        if(form_field_answer) {
          return (
            <div className="col-sm-4" key={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.field_type} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields}  />
                <br></br>
                <textarea className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control signature-generator has-errors" : "form-control signature-generator"} name={form_field.field_type} id={form_field.id} value={form_field_answer ? form_field_answer : ""} style={{fontFamily: 'cursive', textAlign: 'center', fontSize: '20px'}} readOnly={true}/>
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          )
        } else {
          return (
            <div className="col-sm-4" key={form_field.id}>
              <div className="form-group">
                <label>{`${form_field.field}${form_field.required === true ? '*' : ""}`}</label>
                <input className={this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[form_field.field] ? "form-control has-errors" : "form-control"} name={form_field.field_type} id={form_field.id} value={form_field_answer ? form_field_answer : ""} onChange={this.onChangeFormFields}  />
                {this.renderFieldErrors(form_field.field)}
              </div>
            </div>
          )
        } 
      }

      if(form_field.field_type == "image") {
        return(
          <div className="col-sm-4" key={form_field.id}>
            <div className="form-group">
              <SurveyFormFileUploadBuilder nested={true} read_only={false} onChange={this.props.onChangeFileUploadGroup ? this.props.onChangeFileUploadGroup : this.onChangeFileUploadGroup} file_upload_groups={this.state.file_upload_group ? this.state.file_upload_group : [{ file_uploads: [] }]} singleFile={true} form_field_id={form_field.id} form_field={form_field} renderHeaderErrors={this.renderHeaderErrors} renderFieldErrors={this.renderFieldErrors}  />
              {this.renderFieldErrors(form_field.field)}
            </div>
          </div>   
        )
      }
    });

    return (
      <div className="form-group">
        <img src={this.props.logo_image_url} style={{width: 200, height: 'auto', paddingBottom: '10px', marginBlockStart: '20px'}}></img>
        <br />
        <h4>{this.props.title}</h4>
        <br/>
        <i>{this.props.description}</i>
        <hr/>
        {formFields}  
      </div>
    );
  }

  renderEmojiRatingForm(form_field, current_emoji_answer) {
    var rating_range = 5
    var rating_range_arr = []

    for(let index = 0; index < rating_range; index++) {
      rating_range_arr.push(index + 1)  
    }

    var rating_range_lines = rating_range_arr.map((rating) => {
      if(rating_range == 5) {
        if(rating == 1) {
          var list_emoji = <i className="far fa-frown-open fa-2x"></i>
        }
        else if(rating == 2) {
          var list_emoji = <i className="far fa-frown fa-2x"></i>        
        } else if (rating == 3) {
          var list_emoji = <i className="far fa-meh fa-2x"></i>
        } else if (rating == 4) {
          var list_emoji = <i className="far fa-smile fa-2x"></i>   
        } else {
          var list_emoji = <i className="far fa-grin fa-2x"></i>
        }    
      }     
      return (
        <li className={current_emoji_answer.selected == true && current_emoji_answer.answer == rating ? `selected-emoji-scale-li` : `emoji-scale-li`}  onClick={() => this.onChangeSelectedEmoji(rating, form_field)} key={rating}>{list_emoji}</li>
      )
    })
    
    if(this.state.rating_range != 'none') {
      return (
        <ul className="emoji-scale-ul">
          {rating_range_lines}
        </ul>
      )
    } 
  }


  renderRatingRangeForm(form_field, current_rating_answer) {
    if(form_field && form_field.rating_range.rating_range.length > 0) {
      var rating_range = parseInt(form_field.rating_range.rating_range, 10)
      var rating_range_arr = []

      for(let index = 0; index < rating_range; index++) {
        rating_range_arr.push(index + 1)  
      }

      var rating_range_lines = rating_range_arr.map((rating) => {
        if(rating_range == 10) {
          if(rating <= 3){
            var color = "#aa381d"
          } else if (rating > 3 && rating <= 6) {
            var color = "#d18140"
          } else if (rating > 3 && rating <= 6) {
            var color = "#bba350"
          } else {
            var color = "#61a544"
          }
        }

        if(rating_range == 5) {
          if(rating < 3){
            var color = "#aa381d"
          } else if (rating  == 3) {
            var color = "#bba350"
          } else if (rating > 3 && rating <= 6) {
            var color = "#61a544"
          } else {
            var color = "#61a544"
          }
        }    
        return (
          <li className={current_rating_answer.selected == true && current_rating_answer.answer == rating ? "selected-rating-scale-li" : "rating-scale-li"}  onClick={() => this.onChangeSelectedRating(rating, form_field)} key={rating} style={{borderColor: color, color: color}}>{rating}</li>
        )
      })
    }
    if(this.state.rating_range != 'none') {
      return (
        <ul className="rating-scale-ul">
          {rating_range_lines}
        </ul>    
      )
    } 
  }


    // /** Change Handlers **/

  onChangeDate(date, id) {
    this.onChangeFormFields({
      target: {
        name: 'date',
        value: date,
        id: id
      }
    });
  }

  onChangeSurveyFormFields(event) {
    if (event && event.target) {
      this.setState({form_fields: event.target.value})  
    }
  }

  onChangeFormFields(e) {
    var answers = this.state.answers
      this.state.form_fields.map((field) => {
        if(field.id === e.target.id) {
          var found = false;
          if(answers) {
            for(var i = 0, ilen = answers.length; i < ilen; i++) {
              if (answers[i].form_field_id === e.target.id) {
                found = true;
                break;
              }
            }
          }
          if (found) {
            answers.map(answer => {
              if (answer.form_field_id === e.target.id) {
                if(e.target.name == 'number') {
                  answer.answer = e.target.value
                } else if(e.target.name == 'date') {
                  answer.answer = e.target.value
                } else if(e.target.name == "Signature Generator") {
                    answer.answer = e.target.value.replace(/[^\w\s]/gi, '')                
                } else {
                  answer.answer = e.target.value
                }
              }
            })
          } else {
            if(!answers) {
              answers = []
            }
            if(e.target.name == 'number') {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value,
                type: 'number'
              }
            } else if (e.target.name == 'date') {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value,
                type: 'date'
              }
            } else if(e.target.name == "Signature Generator") {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value.replace(/[^\w\s]/gi, '')
              }

            } else {
              var new_answer = {
                form_field_id: e.target.id,
                answer: e.target.value
              }
            }
            answers.push(new_answer)
          }
        }
      }) 
    this.setState({answers: answers})
  }

  onChangeSelectedEmoji(emoji, form_field) {
    var answers = this.state.emoji_answers
    this.state.form_fields.map((field) => {
      if(field.id === form_field.id) {
        var found = false;
        if(answers) {
          for(var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field.id) {          
              answer.answer = emoji + ""
              answer.form_field_id = form_field.id
              answer.form_field_type = form_field.field_type
              answer.selected = !answer.selected
              
            } 
          })
        } else {
          if(!answers) {
            answers = []
          }
          var new_answer = {
            answer: emoji + "",
            form_field_id: form_field.id,
            form_field_type: form_field.field_type,
            selected: true
          }
          answers.push(new_answer)
        }
      }
    })
    this.setState({emoji_answers: answers})
  }

  onChangeSelectedRating(rating, form_field){
    var answers = this.state.rating_answers
    this.state.form_fields.map((field) => {
      if(field.id === form_field.id) {
        var found = false;
        if(answers) {
          for(var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field.id) {
             
              answer.answer = rating + ""
              answer.form_field_id = form_field.id
              answer.form_field_type = form_field.field_type
              answer.selected = !answer.selected
              
            } 
          })
        } else {
          if(!answers) {
            answers = []
          }
          var new_answer = {
            answer: rating + "",
            form_field_id: form_field.id,
            form_field_type: form_field.field_type,
            selected: true
          }
          answers.push(new_answer)
        }
      }
    })
    this.setState({rating_answers: answers})
  }

  onChangeFileUploadGroup(file_upload_group, form_field_id) {
    if (file_upload_group) {
      this.setState({
        file_upload_group: [file_upload_group],
        customer_image_form_field_id: form_field_id
      })
    }
  }

  capitalizeFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
  }


  
  
  // /** Error Handling **/

  renderFieldErrors(key, numberSpinner) {
    if (this.state.errors && this.state.errors.field_errors && this.state.errors.field_errors[key]) {
      var error = this.state.errors.field_errors[key][0]
      if(numberSpinner == true) {
        return (
          <div className="help-block">
            <ul><li style={{textAlign: "left"}}><b>&#x2022;</b>{error}</li></ul>
          </div>
        );
      } else {
        return (
          <div className="help-block">
            <ul><li><b>&#x2022;</b>{error}</li></ul>
          </div>
        );
      };
    };
  }

  renderHeaderErrors() { 
    if (this.state.errors && this.state.errors.header_errors) {
      var errors = this.state.errors.header_errors.map((error, idx) => <li key={idx}>{error}</li>)
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    };
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = ''
    } else {
      var classname = 'form-control';
    }
    if(this.state.errors && this.state.errors.header_errors){

      this.state.errors.header_errors.forEach((error) => {
        if (error == `${this.capitalizeFirstLetter(field)} can't be blank `) {
          classname = classname + ' has-errors'   
        }
      })   
      return classname
    }
  }
 
  // /** AJAX Calls **/

  onSubmit() {
    var self = this  
    self.setState({ loading: true})
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: self.props.survey_answers_save_path,
        data: {
          answers: self.state.answers ? JSON.stringify(self.state.answers) : null,
          rating_answers: self.state.rating_answers.length > 0 ? JSON.stringify(self.state.rating_answers.filter((answer) => answer.selected == true)) : null,
          emoji_answers: self.state.emoji_answers.length > 0 ? JSON.stringify(self.state.emoji_answers.filter((answer) => answer.selected == true)) : null,
          reservation_segment_id: self.props.reservation_segment_id,
          customer_file_upload: self.state.file_upload_group,
          customer_image_form_field_id: self.state.customer_image_form_field_id,
        },
      }).done(function (data) { 
        if (data && data.errors) {
          self.setState({errors: data.errors, success: null, loading: false});
        } else {  
        if (parent && parent.refresh_data) {
          if (self.props.is_new == true) {
            parent.refresh_data(I18n.t('form_created_successfully'));
          } else {
            parent.refresh_data(I18n.t('form_saved_successfully'));
          }
        }
        if (parent && parent.hide_modal) {
          parent.hide_modal()
        }
        window.location.href = '/portal/survey-completion'
        }
      })
    }, 1000)
  }; 
}

export default TestSurveyForm